/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Fleet_Last_UpdateInputs */

const vi_fleet_last_update = /** @type {(inputs: Fleet_Last_UpdateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cập nhật: ${i?.time}`)
};

/**

* @param {Fleet_Last_UpdateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fleet_last_update = /** @type {((inputs: Fleet_Last_UpdateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fleet_Last_UpdateInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fleet_last_update(inputs)
});